import { Typography } from '@sanlam-glacier/app-common/components';
import clsx from 'clsx';
import styles from './widget-loader.module.scss';
import WidgetLoadingSpinner from 'modules/dashboard/components/atoms/widget-loading-spinner/WidgetLoadingSpinner';

const WidgetLoader = () => {
  return (
    <div className={clsx(styles.widgetLoader)}>
      <div className={clsx(styles.loaderContainer)}>
        <div className={clsx(styles.loader)}>
          <WidgetLoadingSpinner />
        </div>
        <Typography
          color={Typography.COLOR.SECONDARY}
          variant={Typography.VARIANT.B2}
          weight={Typography.WEIGHT.MEDIUM}
        >
          <div className={styles.loadingText}>Loading...</div>
        </Typography>
      </div>
    </div>
  );
};

export default WidgetLoader;
